module.exports = __webpack_public_path__ + "0fc89e71133d337a6831dfdd237e1eb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_45.jpg
// module id = 1781
// module chunks = 5